export default "__VITE_ASSET__CZFgFCdR__"